import React from 'react';
import CustomDialog from 'shared/CustomDialog';
import { IContract } from 'pages/ContractManagment/ContractManagement.models';
import RequestCompleteModalContent from 'pages/ContractManagment/ContractManagementList/RequestsActions/RequestCompleteModal/RequestCompleteModalContent';

interface IRequestCompleteModalProps {
  isOpen: boolean;
  onCloseModal: ()=> void;
  selectedContracts: IContract[];
}

const RequestCompleteModal: React.FC<IRequestCompleteModalProps> = ({
  isOpen,
  onCloseModal,
  selectedContracts,
}) => (
  <CustomDialog
    isModalOpen={isOpen}
    onCloseModal={onCloseModal}
    renderChildren={(onClose) => (
      <RequestCompleteModalContent
        onCloseModal={onClose}
        selectedContracts={selectedContracts}
      />
    )}
  />
);

export default RequestCompleteModal;
